import { FC } from 'react';
import { ListStyled } from './style';
import { Props } from './types';

const List: FC<Props & { children?: any }> = ({ children, ...restProps }) => (
  <ListStyled {...restProps}>{children}</ListStyled>
);

export default List;
